import { Theme, ThemeOptions } from "@mui/material/styles";
import type {} from "@mui/x-data-grid-pro/themeAugmentation";
import { lineHeight, rem } from "utils";

import {
  base,
  blueLight,
  error,
  gray,
  primary,
  rose,
  success,
  warning,
} from "./colors";
import { shadows } from "./shadows";
import { HTMLFontSize } from "./variables";

const GlobalTheme: ThemeOptions = {
  spacing: 4, // 4px for 1 unit
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  palette: {
    primary: {
      ...primary,
      main: primary[600],
    },
    error: {
      ...error,
      main: error[600],
    },
    success: {
      ...success,
      main: success[600],
      contrastText: "#fff",
    },
    warning: {
      ...warning,
      main: warning[600],
      contrastText: "#fff",
    },
    grey: gray,
    info: {
      ...blueLight,
      main: blueLight[600],
      contrastText: "#fff",
    },
    secondary: {
      ...rose,
      main: rose[600],
    },
    action: {},
  },
  typography: {
    fontFamily: "var(--font-family)",
    htmlFontSize: HTMLFontSize,
    body1: {
      fontSize: "1rem",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (theme: Theme) => ({
        body: {
          // backgroundColor: primary[700],
          color:
            theme.palette.mode === "dark"
              ? base.White
              : theme.palette.text.primary,
        },
      }),
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiFormLabel-asterisk": {
            color: theme.palette.error.main,
          },
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          "&": {
            textTransform: "none",
            // padding: "8px 14px",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme }) => ({
          "&": {
            backgroundColor:
              theme.palette.mode === "dark" ? base.White : gray[900],
            color: theme.palette.mode === "dark" ? gray[700] : base.White,
            padding: "8px 12px",
            fontSize: rem(12),
            fontWeight: 600,
          },
        }),
        arrow: ({ theme }) => ({
          "&": {
            color: theme.palette.mode === "dark" ? base.White : gray[900],
          },
        }),
      },
    },
    MuiAvatarGroup: {
      styleOverrides: {
        root: {
          "&": {
            flexDirection: "row",
            marginRight: "8px",
          },
        },
        avatar: {
          "&": {
            backgroundColor: gray[100],
            color: gray[600],
            fontSize: rem(16),
            lineHeight: lineHeight(24),
            fontWeight: 600,
            marginLeft: "unset",
            marginRight: "-8px",
          },
          "&:first-child": {
            order: 2,
            zIndex: 2,
          },
        },
      },
    },
    // @ref https://mui.com/x/react-data-grid/getting-started/#typescript
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "&": {
            borderRadius: "12px",
            borderColor: gray[200],
            boxShadow: shadows.xs,
          },
        },
        columnHeaders: {
          "&": {
            borderRadius: "12px 12px 0 0",
            background: gray[50],
            borderColor: gray[200],
          },
          "&.MuiDataGrid-withBorderColor": {
            borderColor: gray[200],
          },
        },
        columnHeader: {
          "&": {
            fontSize: rem(12),
            lineHeight: lineHeight(18),
            fontWeight: 500,
            "&:first-child": {
              borderTopLeftRadius: "12px",
            },
            "&:last-child": {
              borderTopRightRadius: "12px",
            },
            "&:not(.MuiDataGrid-columnHeaderCheckbox)": {
              padding: "7px 14px",
            },
          },
          "&--filledGroup": {
            // background: ColorVariables.DodgerBlue,
            // borderLeft: `1px solid ${ColorVariables.AntiFlashWhite2}`,
          },
          "&--filledGroup.TLN-MuiDataGrid-columnHeader--editingGroup": {
            // background: ColorVariables.DarkCoral,
          },
          "&--filledGroup .MuiDataGrid-columnHeaderTitleContainer": {
            // borderBottom: "unset",
            // display: "flex",
            // justifyContent: "center",
          },
          "&--filledGroup .MuiDataGrid-columnHeaderTitle": {
            // color: ColorVariables.White,
            // fontWeight: 700,
          },
        },
        row: {
          "&": {
            // transition: "background .3s",
            // height: "56px",
          },
          "&:hover": {
            // background: ColorVariables.Snow,
          },
          "&--editing": {
            // boxShadow: "unset",
          },
          "&--editing .MuiDataGrid-cell": {
            // background: ColorVariables.FloralWhite,
          },
        },
        cell: {
          "&": {
            padding: "7px 14px",
            borderColor: gray[200],
          },
        },
        footerContainer: {
          "&": {
            // borderTopColor: ColorVariables.AntiFlashWhite2,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "14px",
          padding: "8px 14px !important",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          fontSize: "14px",
        },
      },
    },
    // MuiTypography: {
    //   styleOverrides: {
    //     root: {
    //       fontSize: "14px !important",
    //       lineHeight: "20px !important",
    //     },
    //   },
    // },
    // MuiSelect: {
    //   styleOverrides: {
    //     select: {
    //       fontSize: "14px !important",
    //     },
    //   },
    // },
  },
};

export default GlobalTheme;
